module.exports = __webpack_public_path__ + "img/TextureWood.a6931a5d.png";